import { render } from "./CTab.vue?vue&type=template&id=5f7dc389"
import script from "./CTab.vue?vue&type=script&lang=js"
export * from "./CTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__